mutation UpdateCompetitors(
  $boardId: ID!
  $updates: [StreamToolsCompetitorUpdateInput!]!
) {
  scoreboard: StreamToolsUpdateCompetitors(
    boardId: $boardId
    updates: $updates
  ) {
    boardId
    version
    competitors {
      competitorId
      boardId
      name
      score
      nameTextColor
      scoreTextColor
      imageUrl
      scoreImageUrl
    }
  }
}
